
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Onlinecabbookingnavimumbai() {



const cardData = {
  keyword: 'Online Cab Booking Navi Mumbai Airport',
  heading: 'Skyline Cabs: Online Cab Booking Navi Mumbai Airport',
  headingDescription: 'Skyline Cabs provides fast, secure, and reliable Online Cab Booking Navi Mumbai Airport services for smooth airport transfers. Whether you need instant cab booking Navi Mumbai Airport, advance cab booking Navi Mumbai Airport, or 24x7 online cab booking Navi Mumbai Airport, our platform ensures quick confirmation and transparent pricing. With professional chauffeurs, AC sedan, SUV, Ertiga, Innova, and Innova Crysta options, we offer complete flexibility for pickup and drop transfers. Our navi mumbai airport online cab booking system is designed for convenience, allowing travelers to book cab online Navi Mumbai Airport within seconds. From early morning online cab booking Navi Mumbai Airport to late night online cab booking Navi Mumbai Airport, Skyline Cabs guarantees punctual service and secure payment processing for a stress-free travel experience.',

  top: 'Top Places to Visit in Navi Mumbai with Skyline Cabs',

  topPlaces: [
    {
      title: "Central Park, Kharghar",
      description: "Central Park is one of the largest urban parks in Navi Mumbai offering jogging tracks, landscaped gardens, and cultural event spaces. It provides peaceful surroundings and scenic hill views. Families and fitness enthusiasts frequently visit this location. It is ideal for relaxation and outdoor activities. Skyline Cabs ensures comfortable airport transfers for travelers exploring Navi Mumbai."
    },
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is known for its scenic sea-facing drive connecting major parts of Navi Mumbai. It offers breathtaking sunset views and smooth infrastructure. The road is ideal for long drives and photography. It is one of the city’s most iconic stretches."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historic structure offering panoramic views of Navi Mumbai and creek areas. It reflects architectural heritage and peaceful surroundings for visitors."
    },
    {
      title: "Pandavkada Waterfalls",
      description: "Pandavkada Waterfalls is a beautiful monsoon destination surrounded by hills and greenery. It is popular among nature lovers and trekkers."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium is a major sports and entertainment venue hosting cricket matches and concerts. It is a prominent landmark in Navi Mumbai."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple is a peaceful spiritual destination inspired by Tirupati architecture. It offers serene surroundings and religious importance."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination offering branded stores and dining options."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is an eco-tourism spot known for bird watching and trekking trails surrounded by greenery."
    },
    {
      title: "Rock Garden, Nerul",
      description: "Rock Garden offers sea-facing views and peaceful walking paths for families and couples visiting Navi Mumbai."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is known for its vibrant European-style architecture and lively atmosphere surrounded by cafes and restaurants."
    }
  ],

  services: [
    {
      name: "Instant Online Cab Booking Navi Mumbai Airport",
      description: "Skyline Cabs offers instant cab booking Navi Mumbai Airport through our advanced online cab booking Navi Mumbai Airport platform that allows travelers to complete navi mumbai airport online cab booking within seconds. Whether you need online taxi booking Navi Mumbai Airport for immediate pickup or urgent drop service, our system ensures quick confirmation, transparent fare details, secure digital payments, and real-time driver allocation. With 24x7 online cab booking Navi Mumbai Airport availability, customers can book cab online Navi Mumbai Airport anytime including late night online cab booking Navi Mumbai Airport and early morning online cab booking Navi Mumbai Airport without delays. Our reliable online cab booking Navi Mumbai Airport service ensures punctual arrival and comfortable airport transfers every time."
    },
    {
      name: "Advance Online Cab Booking Navi Mumbai Airport",
      description: "Plan your journey in advance with advance cab booking Navi Mumbai Airport using Skyline Cabs’ best online cab booking Navi Mumbai Airport system designed for scheduled airport transfers. Customers can complete navi mumbai airport cab booking online days or weeks before travel, ensuring confirmed availability and fixed pricing. Our online cab booking Navi Mumbai Airport service supports corporate travel, family airport transfers, and business schedules with guaranteed pickup timing and driver coordination. Whether it is cheap online cab booking Navi Mumbai Airport or premium Innova Crysta booking, we provide secure booking confirmation, driver details, and automated reminders. Our reliable online cab booking Navi Mumbai Airport ensures zero last-minute stress."
    },
    {
      name: "24x7 Online Taxi Booking Navi Mumbai Airport",
      description: "Skyline Cabs operates 24x7 online cab booking Navi Mumbai Airport for passengers arriving at any hour. From late night online cab booking Navi Mumbai Airport to early morning online cab booking Navi Mumbai Airport, our platform remains active round-the-clock for instant and advance reservations. Travelers can book cab online Navi Mumbai Airport for sedan, SUV, Ertiga, Innova, or Innova Crysta with immediate confirmation and transparent pricing. Our navi mumbai airport online cab booking system ensures professional chauffeur allocation, real-time tracking, and safe airport pickup experience. Whether searching for best online cab booking Navi Mumbai Airport or reliable online cab booking Navi Mumbai Airport, Skyline Cabs guarantees dependable service."
    },
    {
      name: "Affordable & Reliable Online Cab Booking Navi Mumbai Airport",
      description: "Choose Skyline Cabs for cheap online cab booking Navi Mumbai Airport without compromising safety or comfort. Our online taxi booking Navi Mumbai Airport platform provides transparent fare structure with no hidden charges and instant digital confirmation. Customers looking for best online cab booking Navi Mumbai Airport benefit from professional drivers, sanitized AC vehicles, and punctual airport pickup service. Whether you require instant cab booking Navi Mumbai Airport, advance cab booking Navi Mumbai Airport, or one-click navi mumbai airport cab booking online, we provide smooth and secure reservations. Our reliable online cab booking Navi Mumbai Airport system ensures hassle-free transfers with complete customer support."
    }
  ],

  tableData: [
    ["Online Cab Booking Navi Mumbai Airport", "Navi Mumbai Airport Online Cab Booking"],
    ["Book Cab Online Navi Mumbai Airport", "Navi Mumbai Airport Cab Booking Online"],
    ["Online Taxi Booking Navi Mumbai Airport", "Best Online Cab Booking Navi Mumbai Airport"],
    ["Cheap Online Cab Booking Navi Mumbai Airport", "Reliable Online Cab Booking Navi Mumbai Airport"],
    ["Instant Cab Booking Navi Mumbai Airport", "Advance Cab Booking Navi Mumbai Airport"],
    ["24x7 Online Cab Booking Navi Mumbai Airport", "Late Night Online Cab Booking Navi Mumbai Airport"],
    ["Early Morning Online Cab Booking Navi Mumbai Airport", "Instant Online Cab Booking Navi Mumbai Airport"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Secure & Fast Online Booking Platform",
      WhyChoosedescription: "Our online cab booking Navi Mumbai Airport platform is designed for speed, security, and instant confirmation. Customers can book cab online Navi Mumbai Airport within seconds with encrypted payment gateways and automated booking confirmations."
    },
    {
      WhyChooseheading: "24x7 Availability for Airport Transfers",
      WhyChoosedescription: "We provide 24x7 online cab booking Navi Mumbai Airport including late night and early morning airport transfers with guaranteed availability."
    },
    {
      WhyChooseheading: "Transparent Pricing Structure",
      WhyChoosedescription: "Our cheap online cab booking Navi Mumbai Airport offers clear fare breakdown with no hidden charges ensuring budget-friendly travel."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription: "Experienced and verified drivers ensure safe and punctual airport pickup and drop services."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription: "Choose from sedan, SUV, Ertiga, Innova, and Innova Crysta based on comfort and luggage requirements."
    },
    {
      WhyChooseheading: "Instant Confirmation & Driver Details",
      WhyChoosedescription: "Get immediate confirmation, driver contact information, and live tracking for smooth airport travel."
    },
    {
      WhyChooseheading: "Reliable & On-Time Service",
      WhyChoosedescription: "Our reliable online cab booking Navi Mumbai Airport guarantees punctual airport arrival without delays."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly Service",
      WhyChoosedescription: "We support corporate billing and family airport transfers with secure and organized travel solutions."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I do Online Cab Booking for Navi Mumbai Airport with Skyline Cabs?',
        answer:
            'You can complete your Online Cab Booking for Navi Mumbai Airport directly through our website or mobile app. Enter your pickup or drop location, select your preferred vehicle, choose the date and time, and confirm instantly.',
    },
    {
        id: 2,
        question: 'Is Online Cab Booking for Navi Mumbai Airport available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Online Cab Booking for Navi Mumbai Airport, ensuring you can schedule rides anytime for early morning or late-night flights.',
    },
    {
        id: 3,
        question: 'Can I schedule my Navi Mumbai Airport cab online in advance?',
        answer:
            'Absolutely. Our Online Cab Booking Navi Mumbai Airport service allows you to pre-book your ride for any future date and time for guaranteed availability.',
    },
    {
        id: 4,
        question: 'What vehicles are available for Online Cab Booking Navi Mumbai Airport?',
        answer:
            'We offer a wide fleet including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars for airport transfers — suitable for solo travelers, families, and corporate clients.',
    },
    {
        id: 5,
        question: 'Is the fare shown during online booking final?',
        answer:
            'Yes, the fare displayed during Online Cab Booking Navi Mumbai Airport includes tolls, taxes, and driver charges. There are no hidden fees.',
    },
    {
        id: 6,
        question: 'Are secure online payment options available?',
        answer:
            'Yes, we provide secure payment options including UPI, credit/debit cards, and net banking. You will receive instant booking confirmation after payment.',
    },
    {
        id: 7,
        question: 'Can I book a one-way airport cab online?',
        answer:
            'Yes, you can select the one-way option while making your Online Cab Booking Navi Mumbai Airport and pay only for the distance traveled.',
    },
    {
        id: 8,
        question: 'Do you provide real-time tracking after online booking?',
        answer:
            'Yes, once your booking is confirmed, you will receive driver details and real-time tracking updates for complete transparency and safety.',
    },
    {
        id: 9,
        question: 'Is Online Cab Booking Navi Mumbai Airport suitable for corporate travel?',
        answer:
            'Definitely. Skyline Cabs provides professional drivers, clean vehicles, punctual service, and billing support for corporate airport transfers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Online Cab Booking Navi Mumbai Airport?',
        answer:
            'Skyline Cabs ensures quick booking, transparent pricing, reliable airport pickups, sanitized vehicles, and 24x7 customer support — making your Online Cab Booking Navi Mumbai Airport experience smooth and hassle-free.',
    },
];

const someReviews = [
    {
        name: "Mr. Sandeep More",
        rating: 5,
        review: "Used Skyline’s Online Cab Booking Navi Mumbai Airport service and it was extremely easy. Quick confirmation, fair pricing, and timely pickup. Very impressed!"
    },
    {
        name: "Ms. Priya Shah",
        rating: 4,
        review: "Booking my airport cab online was smooth and convenient. The driver arrived on time and the journey was comfortable. Highly recommend Skyline Cabs."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Navi Mumbai Airport",
  "image": "https://skylinecabs.com/assets/images/online-cab-booking-navi-mumbai-airport.jpg",
  "description": "Book Online Cab Booking Navi Mumbai Airport with Skyline Cabs for instant, reliable and affordable airport transfers. 24x7 advance and last-minute cab booking available for pickup and drop with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "899",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/online-cab-booking-navi-mumbai-airport"
  }
};


    return (
        <div>

<Helmet>
  <title>Online Cab Booking Navi Mumbai Airport | 24x7 Airport Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Online Cab Booking Navi Mumbai Airport with Skyline Cabs for instant and advance airport taxi service. Reliable, affordable and 24x7 airport pickup and drop available." 
  />
  <meta 
    name="keywords" 
    content="online cab booking navi mumbai airport, navi mumbai airport online cab booking, book cab online navi mumbai airport, navi mumbai airport cab booking online, online taxi booking navi mumbai airport, best online cab booking navi mumbai airport, cheap online cab booking navi mumbai airport, reliable online cab booking navi mumbai airport, instant cab booking navi mumbai airport, advance cab booking navi mumbai airport, 24x7 online cab booking navi mumbai airport, late night online cab booking navi mumbai airport, early morning online cab booking navi mumbai airport, Skyline Cabs Online Navi Mumbai Airport Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/118.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onlinecabbookingnavimumbai;